import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup } from '@pattern-library/buttons';
import { WarningBoldIcon } from '@pattern-library/icon';
import TextInput from '@pattern-library/text-input';
import PasswordReveal from '@pattern-library/password-reveal';
import useUnifiedLoginFormValidation from '../../hooks/useUnifiedLoginFormValidation';
import useCapsLockDetection from '../../hooks/useCapsLockDetection';
import { getFingerprint } from '../../utilities/fingerprint';

const propTypes = {
    buttonProps: PropTypes.objectOf(PropTypes.string).isRequired,
    formAction: PropTypes.string.isRequired,
    loginType: PropTypes.string.isRequired,
    passwordRevealProps: PropTypes.objectOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.array])
    ).isRequired,
    returnQueryString: PropTypes.string,
    userExperience: PropTypes.oneOf([0, 1]),
    usernameInputProps: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.array]))
        .isRequired
};

function LoginForm(props) {
    const {
        buttonProps,
        formAction,
        loginType,
        passwordRevealProps,
        returnQueryString,
        userExperience,
        usernameInputProps
    } = props;

    const {showCapsLockWarning} = useCapsLockDetection();

    const { validation: usernameValidateMethods, ...usernameProps } = usernameInputProps;
    const { validation: passwordValidateMethods, ...passwordProps } = passwordRevealProps;
    const username = usernameProps.name;
    const password = passwordProps.name;

    /**
     * @type { import('@pattern-library/base/dist/js/hooks/useFormValidation').FormValidationSchema}
     */
    const schema = {
        [username]: usernameValidateMethods,
        [password]: passwordValidateMethods
    };

    const { onSubmit, hasError, errorMessage } = useUnifiedLoginFormValidation({
        schema
    });

    return (
        <div className="ul-login-form">
            <form
                action={formAction}
                method="post"
                autoComplete="off"
                onSubmit={onSubmit}
                noValidate
            >
                <input type="hidden" id="RetQs" name="RetQs" value={returnQueryString || ''} />
                <input
                    type="hidden"
                    id="UserExp"
                    name="UserExp"
                    value={userExperience ? `${userExperience}` : ''}
                />
                <input type="hidden" id="Type" name="Type" value={loginType} />
                <input type="hidden" id="DeviceFingerprint" name="DeviceFingerprint" value={getFingerprint()} />
                <TextInput
                    isRequired
                    autoComplete="off"
                    useEmbeddedLabel
                    hasError={hasError(username)}
                    errorMessage={errorMessage(username)}
                    {...usernameProps}
                />
                <PasswordReveal
                    isRequired
                    preventAutofill
                    useEmbeddedLabel
                    hasError={hasError(password)}
                    errorMessage={errorMessage(password)}
                    {...passwordProps}
                />
                {showCapsLockWarning && (
                    <div className="asc-form-help ul-login-form-caps-lock-warning asc-nmt-5">
                        <WarningBoldIcon customSize="14px" color="warning" className="asc-form-help-icon" />
                        <p className="asc-form-help--error-message">Caps Lock is on</p>
                    </div>
                )}
                <ButtonGroup alignment="center" className="asc-mb-4 asc-mt-3">
                    <Button type="submit" className="asc-mtb-0" {...buttonProps} />
                </ButtonGroup>
            </form>
        </div>
    );
}

LoginForm.propTypes = propTypes;
export default LoginForm;
